import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "root-order-status" };
const _hoisted_2 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_OrderStatusChip = _resolveComponent("OrderStatusChip");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterList, (filterId, key) => {
            return (_openBlock(), _createElementBlock("div", {
                key: key,
                class: _normalizeClass(["filter-item", _ctx.getLabelClass(filterId)]),
                onClick: ($event) => (_ctx.handleClickFilter(filterId))
            }, [
                _createVNode(_component_OrderStatusChip, {
                    class: "root-order-status-chip",
                    "status-code": filterId
                }, null, 8 /* PROPS */, ["status-code"]),
                _createTextVNode(" " + _toDisplayString(_ctx.orderTotal[filterId]), 1 /* TEXT */)
            ], 10 /* CLASS, PROPS */, _hoisted_2));
        }), 128 /* KEYED_FRAGMENT */))
    ]));
}
